/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_Enabled_ToastInputs */



/**
* | output |
* | --- |
* | "External device control activated" |
*
* @param {Creator_Ext_Device_Enabled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_enabled_toast = /** @type {((inputs?: Creator_Ext_Device_Enabled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_Enabled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Controle d'appareil externe active")
	if (locale === "de") return /** @type {LocalizedString} */ ("Externe Gerätesteuerung aktiviert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo del dispositivo esterno attivato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление внешним устройством активировано")
	if (locale === "es") return /** @type {LocalizedString} */ ("Control de dispositivo externo activado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("外部设备控制已激活")
	if (locale === "ja") return /** @type {LocalizedString} */ ("外部デバイス制御が有効")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाह्य उपकरण नियंत्रण सक्रिय हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controle de dispositivo externo ativado")
	return /** @type {LocalizedString} */ ("External device control activated")
});